import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import SEO from "../components/SEO";
import api, { getFullImageUrl } from "../services/api";

const formatDate = (value) => new Intl.DateTimeFormat("vi-VN", {
  day: "2-digit", month: "long", year: "numeric",
}).format(new Date(value));

export default function Articles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/articles?limit=24")
      .then((response) => setArticles(Array.isArray(response.data) ? response.data : []))
      .catch(() => setError("Chưa tải được bài viết. Vui lòng thử lại sau."))
      .finally(() => setLoading(false));
  }, []);

  return <div className="min-h-screen bg-slate-50 dark:bg-slate-950" style={{ zoom: "0.8" }}>
    <SEO title="Bài viết & Cẩm nang giày" description="Cẩm nang chọn giày, phối đồ và chăm sóc giày từ TAHA SHOES." />
    <Navbar />
    <main className="pt-28 sm:pt-40 pb-20 px-4">
      <section className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-10 sm:mb-14">
          <span className="inline-flex px-3 py-1 rounded-full bg-indigo-50 text-indigo-700 text-xs font-bold tracking-widest uppercase">TAHA Journal</span>
          <h1 className="mt-5 text-3xl sm:text-5xl font-black tracking-tight text-slate-950 dark:text-white">Bài viết & Cẩm nang giày</h1>
          <p className="mt-4 text-base sm:text-lg text-slate-600 dark:text-slate-300 leading-relaxed">Kiến thức hữu ích giúp bạn chọn đúng đôi giày, phối đúng phong cách và giữ giày luôn bền đẹp.</p>
        </div>

        {loading ? <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{[0,1,2,3,4,5].map((item) => <div key={item} className="h-80 rounded-3xl bg-white dark:bg-slate-900 animate-pulse border border-slate-100 dark:border-slate-800" />)}</div> : null}
        {error ? <div className="p-6 rounded-2xl bg-rose-50 text-rose-700 font-bold">{error}</div> : null}
        {!loading && !error && articles.length === 0 ? <div className="py-24 text-center rounded-3xl bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800"><div className="text-4xl">✦</div><h2 className="mt-4 text-xl font-black dark:text-white">Bài viết đầu tiên đang được chuẩn bị</h2><p className="mt-2 text-slate-500">Nội dung mới từ TAHA AI sẽ xuất hiện tại đây.</p></div> : null}
        {!loading && articles.length > 0 ? <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{articles.map((article) => <Link to={`/articles/${article.slug}`} key={article._id} className="group overflow-hidden rounded-3xl bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all">
          <div className="aspect-[16/10] overflow-hidden bg-gradient-to-br from-indigo-100 to-blue-50 dark:from-indigo-950 dark:to-slate-900">
            {article.images?.[0] ? <img src={getFullImageUrl(article.images[0])} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /> : <div className="w-full h-full grid place-items-center text-indigo-400 text-4xl">TAHA</div>}
          </div>
          <div className="p-6">
            <time className="text-xs text-slate-500">{formatDate(article.publishedAt)}</time>
            <h2 className="mt-3 text-xl font-black text-slate-950 dark:text-white leading-tight group-hover:text-indigo-600 transition-colors">{article.title}</h2>
            <p className="mt-3 text-sm text-slate-600 dark:text-slate-300 leading-relaxed line-clamp-3">{article.excerpt}</p>
            <span className="mt-5 inline-flex text-sm font-bold text-indigo-600">Đọc bài viết →</span>
          </div>
        </Link>)}</div> : null}
      </section>
    </main>
  </div>;
}
